import React from "react";

import CountUp from "react-countup";
import { Link as SLink } from "react-scroll";

// import { Portfolio } from "./";
import { Divider } from "../img";
import { FaArrowDown } from "react-icons/fa";
import { AboutHeader, Testimonials } from "../components";

import "../css/home.css";
const Home = () => {
  return (
    <div className="home">
      <header>
        <div className="header__txt">
          <h1 className="pip"> </h1>
          <h1>Hossam Rabei</h1>
          <h1 className="pip"> </h1>
          <h2>Pro Photographer</h2>
        </div>

        <div className="header__scroll">
        <SLink smooth={true} to="aboutHeader">
          <div className="scroll">
            {/* <div className="frame">
              <div className="dot"></div>
            </div> */}

            <FaArrowDown className="fa" />
            <h4>scroll</h4>
          </div>
        </SLink>
        </div>
      </header>

      <main>
        <AboutHeader />

        {/* <Portfolio limit={6} /> */}

        <section className="services" id="services">
          <h1>My Services</h1>
          <img src={Divider} alt="wavy line" className="divider" />

          <div className="grid">
            <div>
              <img src="" alt="" />
              <h1>Title</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam,
                quaerat quos blanditiis delectus quae officiis.
              </p>
            </div>

            <div>
              <img src="" alt="" />
              <h1>Title</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam,
                quaerat quos blanditiis delectus quae officiis.
              </p>
            </div>

            <div>
              <img src="" alt="" />
              <h1>Title</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam,
                quaerat quos blanditiis delectus quae officiis.
              </p>
            </div>

            <div>
              <img src="" alt="" />
              <h1>Title</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam,
                quaerat quos blanditiis delectus quae officiis.
              </p>
            </div>

            <div>
              <img src="" alt="" />
              <h1>Title</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam,
                quaerat quos blanditiis delectus quae officiis.
              </p>
            </div>

            <div>
              <img src="" alt="" />
              <h1>Title</h1>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam,
                quaerat quos blanditiis delectus quae officiis.
              </p>
            </div>
          </div>
        </section>

        <section className="skills" id="skills">
          <h1>My Skills</h1>
          <img src={Divider} alt="wavy line" className="divider" />

          <div className="grid">
            <span>
              <h1>
                <CountUp end={100} duration={8} delay={8} />
                <sup>%</sup>
              </h1>
              <h3>Photography</h3>
            </span>

            <span>
              <h1>
                <CountUp end={70} duration={8} delay={8} />
                <sup>%</sup>
              </h1>
              <h3>Writing</h3>
            </span>

            <span>
              <h1>
                <CountUp end={90} duration={8} delay={8} />
                <sup>%</sup>
              </h1>
              <h3>Jam making</h3>
            </span>

            <span>
              <h1>
                <CountUp end={100} duration={8} delay={8} />
                <sup>%</sup>
              </h1>
              <h3>Egyptology</h3>
            </span>
          </div>
        </section>

        <Testimonials />

        <section className="contact" id="contact">
          <h1>Get in touch</h1>
          <img src={Divider} alt="wavy line" className="divider" />

          <div className="info">
              <h5>email</h5>
              <a href="mailto:hossamrabei62@gmail.com">
                <h3>hossamrabei62@gmail.com</h3>
              </a>

              <h5>phone</h5>
              <a href="tel:+201007100084">
                <h3>+201007100084</h3>
              </a>
              {/* <a href="tel:+20123456789">
                <h3>+20123456789</h3>
              </a> */}
              <h5>address</h5>
              <h3>
                Hossam Rabei St. - Mansoura <br /> Dakahlia - Egypt
              </h3>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Home
